/** User-facing strings: errors. */
export const errors = {
    backToDashboard: "Back to dashboard",
    tryAgain: "Try again",
    reference: "Reference: {digest}",
    notFound: {
        title: "Page not found",
        detail: "This page does not exist, or you do not have access to it.",
        backToAgents: "Back to agents",
    },
    failure: {
        title: "Something went wrong",
        detail: "This page could not be shown. Nothing was changed on your account. Try again; if it keeps failing, contact support.",
        globalDetail:
            "The application could not be shown. Nothing was changed on your account. Try again; if it keeps failing, contact support.",
    },
    auth: {
        metadataTitle: "Sign-in problem",
        signInAgain: "Sign in again",
        backToStart: "Back to start",
        help: "If this keeps happening, check that cookies are allowed for this site, or contact support.",
        expired: {
            title: "Your sign-in session expired",
            detail: "The sign-in took too long, or was started in another tab or browser. Nothing was changed on your account. Sign in again to continue.",
        },
        cancelled: {
            title: "Sign-in was cancelled",
            detail: "The sign-in was not completed. Nothing was changed on your account. Sign in again whenever you are ready.",
        },
        notAllowed: {
            title: "This account cannot use OPC UA Relay",
            detail: "You signed in, but this account is not allowed to open this site. Try a different account, or ask your administrator or Sterfive support to give you access.",
        },
        unavailable: {
            title: "Sign-in is temporarily unavailable",
            detail: "We could not reach the sign-in service. Nothing was changed on your account. Wait a minute, then sign in again.",
        },
        generic: {
            title: "We couldn't sign you in",
            detail: "Something went wrong while signing you in. Nothing was changed on your account. Sign in again.",
        },
    },
};
